package top.wcpe.allincore.ui.runtime.element

import kotlin.jvm.JvmStatic

/**
 * 占位伸展元素：在主轴上吃掉剩余空间。
 * 默认 `flexGrow = 1`，与同级元素一同分配剩余空间。
 */
class Spacer private constructor() : UIElement<Spacer>() {

    init {
        styleField.layout().flexGrow = 1f
    }

    protected override fun self(): Spacer = this

    companion object {
        @JvmStatic
        fun create(): Spacer = Spacer()
    }
}
